__turbopack_context__.v({
  "actions": "SourceCard-module__W0Vz3G__actions",
  "badge": "SourceCard-module__W0Vz3G__badge",
  "benefit": "SourceCard-module__W0Vz3G__benefit",
  "benefitNumber": "SourceCard-module__W0Vz3G__benefitNumber",
  "benefits": "SourceCard-module__W0Vz3G__benefits",
  "card": "SourceCard-module__W0Vz3G__card",
  "description": "SourceCard-module__W0Vz3G__description",
  "header": "SourceCard-module__W0Vz3G__header",
  "headerAction": "SourceCard-module__W0Vz3G__headerAction",
  "iconContainer": "SourceCard-module__W0Vz3G__iconContainer",
  "loaderBox": "SourceCard-module__W0Vz3G__loaderBox",
  "title": "SourceCard-module__W0Vz3G__title",
});
